/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateCheckout200ResponseAllOfData } from './UpdateCheckout200ResponseAllOfData';
import {
    UpdateCheckout200ResponseAllOfDataFromJSON,
    UpdateCheckout200ResponseAllOfDataFromJSONTyped,
    UpdateCheckout200ResponseAllOfDataToJSON,
} from './UpdateCheckout200ResponseAllOfData';

/**
 * 
 * @export
 * @interface UpdateCheckout200ResponseAllOf
 */
export interface UpdateCheckout200ResponseAllOf {
    /**
     * 
     * @type {UpdateCheckout200ResponseAllOfData}
     * @memberof UpdateCheckout200ResponseAllOf
     */
    data: UpdateCheckout200ResponseAllOfData;
}

/**
 * Check if a given object implements the UpdateCheckout200ResponseAllOf interface.
 */
export function instanceOfUpdateCheckout200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function UpdateCheckout200ResponseAllOfFromJSON(json: any): UpdateCheckout200ResponseAllOf {
    return UpdateCheckout200ResponseAllOfFromJSONTyped(json, false);
}

export function UpdateCheckout200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCheckout200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': UpdateCheckout200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function UpdateCheckout200ResponseAllOfToJSON(value?: UpdateCheckout200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UpdateCheckout200ResponseAllOfDataToJSON(value.data),
    };
}

